<template>
  <div class="container">
    <div class="row">
      <div class="col-fluid mx-auto">
        <div class="list-group shadow-sm mx-auto mb-5">
          <div class="list-group-item">
            <h3>Application Access</h3>
            <span>Request or manage access to the applications below.</span>
          </div>
          <router-link
            v-for="app in apps"
            :key="app.id"
            class="list-group-item list-group-item-action d-flex justify-content-between"
            :to="getPath(app)"
          >
            <span>
              <EnvBadge :env="app.environment"></EnvBadge>
              <strong class="ml-2">{{ app.title }}</strong>
            </span>
            <UnlockedIcon v-if="hasAccess(app)" style="fill: #555;" />
            <LockedIcon v-else style="fill: #555;" />
          </router-link>
          <div class="list-group-item"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import EnvBadge from "../components/EnvBadge.vue"
import LockedIcon from "../assets/lock.svg"
import UnlockedIcon from "../assets/unlock.svg"
export default {
  components: {
    EnvBadge,
    LockedIcon,
    UnlockedIcon,
  },
  props: {
    apps: { required: true, type: Array },
  },
  methods: {
    hasAccess(app) {
      return app.user_roles.length && !app.user_roles.includes("requester")
    },
    getPath({ user_roles, cognito_id }) {
      const action = user_roles.includes("auth_admin") ? "manage" : "request"
      return `/${action}/${cognito_id}`
    },
  },
}
</script>
